import { ChangeEvent, forwardRef } from 'react';
import styled from 'styled-components';

import { getValidator } from '../../utils/helper';
import { Checkbox } from './Checkbox';

interface Props {
  name: string;
  label: string;
  checked?: boolean;
  color?: string;
  isRequired?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const StylableCheckbox = forwardRef<
  { validate: () => boolean; getValue: () => string },
  Props
>(({ name, label, isRequired, color, onChange }: Props, ref) => {
  const validator = getValidator(name, isRequired);
  return (
    <Checkbox
      ref={ref}
      label={
        <StyledLabel color={color ?? 'white'}>
          <RTFWrapper>
            <div dangerouslySetInnerHTML={{ __html: label }}></div>
          </RTFWrapper>
          {isRequired && <RedStar>*</RedStar>}
        </StyledLabel>
      }
      validator={validator}
      onChange={onChange}
    />
  );
});

const RedStar = styled.span`
  color: red;
  font-size: 16px;
  margin-left: 4px;
`;

const StyledLabel = styled.span<{ color: string }>`
  font-size: 11px;
  text-align: left;
  a {
    color: ${({ color }) => color};
    text-decoration-color: white;
  }
  color: ${({ color }) => color};
  display: flex;
`;

const RTFWrapper = styled.div`
  position: relative;
  width: 100%;
  word-break: break-word;
  p {
    margin: 0;
  }
  p:empty {
    /**
      For empty lines, the tip tap editor represents it with empty paragraph. 
      But when it renders, the tiptap editor injects a br into it.
      Since we are not using tiptap editor for rendering in embed, we need to inject the same height(19.2) to empty paragraph 
    */
    height: 19.2px;
    margin: 0;
  }
  > div {
    outline: none;
    padding: 4px 4px;
    line-height: 1.2;
    border-radius: 5px;
  }
`;
